import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "components/shared/Dialog";
import SimpleTable, { type SimpleTableColumn } from "components/shared/tables/SimpleTable";
import { useCompanyDateFormat } from "utils/hooks/company";
import { dateTimeFormat } from "utils/helpers/date";
import "./styles.scss";

function InfoDialog({ open, close, values }: { open: boolean; close: () => void; values: any }) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    const columns = useMemo<SimpleTableColumn<any>[]>(
        () => [
            {
                header: t("type"),
                cell: (row) => t((row.type as string)?.toLowerCase()),
            },
            {
                header: t("start-date"),
                cell: (row) => dateTimeFormat(row.startDate, dateFormat),
            },
            {
                header: t("end-date"),
                cell: (row) => dateTimeFormat(row.endDate, dateFormat),
            },
            {
                header: t("total"),
                cell: (row) => Number(row.total).toFixed(2),
            },
        ],
        [t, dateFormat],
    );

    return (
        <Dialog title={t("info")} open={open} close={close} size="lg">
            <div className="info-dialog-table">
                <SimpleTable data={values || []} columns={columns} />
            </div>
        </Dialog>
    );
}

export default InfoDialog;
